
import React, { useState } from 'react';
import { useAuth } from '../AuthProvider';
import { baseUrl_SPB } from '../BaseUrl';
import { TextField, Button, Paper, Typography, Alert, Stack } from '@mui/material';

const initialForm = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  businessName: '',
  abn: '',
  address: '',
  notes: '',
  medicalHistoryNotes: '',
};

const AddCustomer = () => {
  const authContext = useAuth();
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    if (!form.firstName) return 'First name is mandatory';
    if (!form.lastName) return 'Last name is mandatory';
    if (!form.email) return 'Email is mandatory';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) return 'Invalid email format';
    if (form.abn && !/^\d{11}$/.test(form.abn)) return 'Invalid ABN format. It should be 11 digits';
    if (form.businessName && /\d/.test(form.businessName)) return 'Business name should not contain numbers';
    // address, notes, and medicalHistoryNotes are optional
    return null;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    const errMsg = validate();
    if (errMsg) {
      setError(errMsg);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl_SPB}/api/v1/businesscustomers/save`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authContext.token,
        },
        body: JSON.stringify(form),
      });
      if (!response.ok) throw new Error('Failed to save customer');
      setSuccess('Customer added successfully!');
      setForm(initialForm);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ padding: 2, maxWidth: 600, margin: '0 auto' }}>
      <Typography variant="h5" gutterBottom>Add New Customer</Typography>
      <form onSubmit={handleSubmit} autoComplete="off">
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
          <TextField label="First Name" name="firstName" value={form.firstName} onChange={handleChange} required fullWidth />
          <TextField label="Last Name" name="lastName" value={form.lastName} onChange={handleChange} required fullWidth />
          <TextField label="Email" name="email" value={form.email} onChange={handleChange} required fullWidth />
          <TextField label="Phone Number" name="phoneNumber" value={form.phoneNumber} onChange={handleChange} fullWidth />
          <TextField label="Business Name" name="businessName" value={form.businessName} onChange={handleChange} fullWidth />
          <TextField label="ABN" name="abn" value={form.abn} onChange={handleChange} fullWidth />
          <TextField label="Address" name="address" value={form.address} onChange={handleChange} fullWidth />
          <TextField label="Notes" name="notes" value={form.notes} onChange={handleChange} fullWidth />
          <TextField label="Medical History Notes" name="medicalHistoryNotes" value={form.medicalHistoryNotes} onChange={handleChange} fullWidth />
          <Button type="submit" variant="contained" color="primary" disabled={loading}>{loading ? 'Saving...' : 'Save Customer'}</Button>
        </Stack>
      </form>
    </Paper>
  );
};

export default AddCustomer;
